import { render } from "./OfferList.vue?vue&type=template&id=239e695c&scoped=true"
import script from "./OfferList.vue?vue&type=script&lang=js"
export * from "./OfferList.vue?vue&type=script&lang=js"

import "./OfferList.vue?vue&type=style&index=0&id=239e695c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-239e695c"

export default script